import { GradientText } from "lola-framework-ui-test";
import { useStore } from "../store/globalState";
import { TransactionItem } from "./TransactionItem";
import type { ITransaction } from "../interfaces/transactions";
import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";
import { ScrollFadeIndicator } from "./ScrollFadeIndicator";


export interface TransactionsHistoryProps {
  items: unknown[];
  title?: string;
  greeting?: string;
  rateCard?: ReactNode;
}

export const TransactionsHistory: React.FC<TransactionsHistoryProps> = ({
  items = [],
  title,
  greeting,
  rateCard,
}) => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { bodyCopy } = colorConfig;
  const isEmpty = items.length === 0;

  return (
    <>
      {greeting ? (
        <GradientText
          className="transaction-title transactions-history-greeting"
          textColor={bodyCopy}
        >
          <b>{greeting}</b>
        </GradientText>
      ) : null}
      {rateCard}
      <GradientText className="normal-text transactions-history-title">
        {title ?? t("transactions.title")}
      </GradientText>
      <section className="transactions-history-container">
        <ScrollFadeIndicator color={bodyCopy} />
        {isEmpty ? (
          <section className="transactions-history-empty">
            <GradientText textColor={bodyCopy} className="empty-title">
              <b>{t("transactions.emptyTitle")}</b>
            </GradientText>
            <GradientText textColor={bodyCopy} className="empty-description">
              {t("transactions.emptyDescription")}
            </GradientText>
          </section>
        ) : (
          <section className="transactions-history-list">
            {items.map((transaction, index) => (
              <TransactionItem key={index} {...(transaction as ITransaction)} />
            ))}
          </section>
        )}
      </section>
    </>
  );
};
